import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Process from "@/components/site/Process";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import { MessageCircle } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Landing() {
  const location = useLocation();

  useEffect(() => {
    document.title = `${SITE.name} — Consultancy, Cleaning & Compliance · Manchester`;
  }, []);

  // Scroll to hash target when navigating to /#section from another route
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      // slight delay to ensure layout is settled
      requestAnimationFrame(() => {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  }, [location]);

  const waLink = `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(
    "Hi Nexaverve — I'd like to enquire about your services."
  )}`;

  return (
    <main data-testid="landing-page" className="relative bg-[#0A0A0A] text-white">
      <Navbar />
      <Hero />
      <Services />
      <About />
      <Process />
      <Contact />
      <Footer />

      {/* Floating WhatsApp */}
      <a
        href={waLink}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-6 right-6 z-40 inline-flex items-center justify-center w-14 h-14 bg-[#25D366] text-black shadow-2xl shadow-black/40 hover:scale-105 transition-transform"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
    </main>
  );
}
